import { useEffect } from "react";
import { useMultiCashoutEnabled } from "../../hooks/useMultiCashoutEnabled";
import { ROUTES } from "../../setup/constants";
import { useNavigate } from "react-router-dom";
import MultiCashouts from "./MultiCashouts";
import Spinner from "../../components/common/Spinner";
import Maintenance from "../../components/common/Maintenance";
import styles from "./cashouts.module.scss";

// TODO: remove once the multi cashouts page is back from maintenance
const IS_UNDER_MAINTENANCE = true;

const MultiCashoutsPage = () => {
  const { isMultiCashoutEnabled, isLoadingMultiCashoutFlag } =
    useMultiCashoutEnabled();

  const navigate = useNavigate();

  useEffect(() => {
    if (IS_UNDER_MAINTENANCE) return;

    if (!isMultiCashoutEnabled && !isLoadingMultiCashoutFlag) {
      navigate(ROUTES.CONTRACT_NOT_FOUND, { replace: true });
    }
  }, [isLoadingMultiCashoutFlag, isMultiCashoutEnabled, navigate]);

  if (IS_UNDER_MAINTENANCE) {
    return <Maintenance />;
  }

  if (isLoadingMultiCashoutFlag) {
    return (
      <div className={styles.loading_container}>
        <Spinner />
      </div>
    );
  }

  if (!isMultiCashoutEnabled) {
    return null;
  }

  return <MultiCashouts />;
};

export default MultiCashoutsPage;
